// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".max-width-200[data-v-1652021e]{max-width:200px}.v-card[data-v-1652021e]{-webkit-transition:all .3s ease;transition:all .3s ease}", ""]);
// Exports
module.exports = exports;
